export default function truthy<T>(i: T): boolean {
	return !!i
}
